<template>
  <div class="header lg:py-20 pt-8 pb-20">
    <div class="md:container px-4">
      <div class="flex flex-wrap md:flex-nowrap justify-between items-center">
        <!-- <img v-lazy-load data-src="@/assets/icon/icon-yd.svg" alt="logo-yesdok-network" class="h-auto mb-4" width="131px" height="56px"> -->
        <!-- <el-dropdown class="text-white rounded-full border border-white px-4 py-1" trigger="click">
          <span class="el-dropdown-link uppercase outline-none flex flex-nowrap items-center">
            <img v-if="$i18n.locale === 'id'" v-lazy-load data-src="@/assets/icon/icon-flag-id.svg" alt="" class="img-flag">
            <img v-else-if="$i18n.locale === 'en'" v-lazy-load data-src="@/assets/icon/icon-flag-en.svg" alt="" class="img-flag">
            <span class="ml-1">{{ $i18n.locale }} <i class="el-icon-arrow-down el-icon&#45;&#45;right" /></span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <template v-for="locale in availableLocales">
              <nuxt-link :key="locale.code" :to="switchLocalePath(locale.code)">
                <el-dropdown-item :disabled="locale.code === $i18n.locale" class="flex items-center">
                  <img v-if="locale.code === 'id'" v-lazy-load data-src="@/assets/icon/icon-flag-id.svg" alt="" class="img-flag">
                  <img v-else-if="locale.code === 'en'" v-lazy-load data-src="@/assets/icon/icon-flag-en.svg" alt="" class="img-flag">
                  <span class="ml-2">{{ locale.name }}</span>
                </el-dropdown-item>
              </nuxt-link>
            </template>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <div class="flex flex-wrap lg:flex-nowrap">
        <div class="w-full lg:w-1/2">
          <h5 class="text-success uppercase tracking-widest lg:text-xl text-lg lg:my-8 mt-16 lg:mt-4 mb-3">
            {{ $t('header.subtitle') }}
          </h5>
          <h1 class="text-white 2xl:text-6xl xl:text-5xl font-bree-serif lg:mb-6 mb-4 uppercase" v-html="$t('header.title')" />
          <p class="text-white mb-6 text-lg leading-6">
            {{ $t('header.desc') }}
          </p>
          <div class="flex flex-wrap xs:flex-nowrap">
            <div class="w-full xs:w-1/2 xs:mr-4 xs:mb-0 mb-4">
              <button class="btn btn-success w-full text-xl uppercase" @click="registerModal = true">
                {{ $t('signup') }}
              </button>
            </div>
            <div class="w-full xs:w-1/2">
              <button class="btn btn-outline-success w-full text-xl uppercase" @click="handleScrollTo('doctor')">
                {{ $t('learn') }}
              </button>
            </div>
          </div>
          <div class="flex flex-wrap xs:flex-nowrap items-center text-white lg:mt-14 mt-6 mb-10">
            <div>
              {{ $t('workingWith') }}
            </div>
            <div class="flex xs:mt-0 mt-4">
              <img
                v-lazy-load data-src="@/assets/icon/icon-chrome-min.png"
                alt="icon-chrome"
                class="inline-block md:mx-8 xs:ml-4 ml-0 mr-6"
                width="32"
                height="32"
                style="visibility: hidden;"
                onload="this.style.visibility= 'visible'"
              >
              <img
                v-lazy-load data-src="@/assets/icon/icon-android-min.png"
                alt="icon-android"
                class="inline-block md:mx-8 mx-6"
                width="31"
                height="36"
                style="visibility: hidden;"
                onload="this.style.visibility= 'visible'"
              >
              <img
                v-lazy-load data-src="@/assets/icon/icon-apple-min.png"
                alt="icon-apple"
                class="inline-block md:mx-8 mx-6"
                width="30"
                height="36"
                style="visibility: hidden;"
                onload="this.style.visibility= 'visible'"
              >
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2">
          <img
            v-lazy-load data-src="@/assets/img/img-header-min.png"
            alt="img-header"
            class="mx-auto"
            style="visibility: hidden;"
            onload="this.style.visibility= 'visible'"
          >
        </div>
      </div>
      <yes-modal
        v-if="registerModal"
        ref="registerModal"
        :image-modal="false"
        text-center
        centered
        bg-backdrop="bg-premier-blue"
        bg-opacity="bg-opacity-90"
        :show-close="true"
        @close="closeModal"
      >
        <div id="registerModal" class="lg:px-10 px-4">
          <img v-lazy-load data-src="@/assets/icon/icon-new-yd.svg" alt="" width="131" height="56">
          <p class="mt-10 text-left text-xl text-center" v-html="$t('titleModalHeader', {type: 'YesDok Network'})" />
          <div class="flex flex-wrap lg:flex-nowrap justify-center items-center my-6">
            <div class="w-full lg:w-1/4 lg:mr-4 lg:mb-0 mb-4">
              <div
                id="register-hospital"
                class="card flex items-center justify-center border-2 border-blue2 cursor-pointer hover:bg-light-blue"
                style="min-height: 180px;"
                :class="{'bg-light-blue': registerType === 'HOSPITAL'}"
                @click="registerType = 'HOSPITAL'"
              >
                <div>
                  <img v-lazy-load data-src="@/assets/icon/icon-rs.svg" alt="" class="mx-auto">
                  <p class="text-primary font-rubik-medium mt-4">
                    {{ $t('hospital') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-1/4 lg:mr-4 lg:mb-0 mb-4">
              <div
                id="register-clinic"
                class="card flex items-center justify-center border-2 border-blue2 cursor-pointer hover:bg-light-blue"
                style="min-height: 180px"
                :class="{'bg-light-blue': registerType === 'CLINIC'}"
                @click="registerType = 'CLINIC'"
              >
                <div>
                  <img v-lazy-load data-src="@/assets/icon/icon-clinic.svg" alt="">
                  <p class="text-primary font-rubik-medium mt-5">
                    {{ $t('clinic') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-1/4 lg:mr-4 lg:mb-0 mb-4">
              <div
                id="register-doctor"
                class="card flex items-center justify-center border-2 border-blue2 cursor-pointer hover:bg-light-blue"
                style="min-height: 180px"
                :class="{'bg-light-blue': registerType === 'DOCTOR'}"
                @click="registerType = 'DOCTOR'"
              >
                <div>
                  <img v-lazy-load data-src="@/assets/icon/icon-doctor.svg" alt="" class="mx-auto">
                  <p class="text-primary font-rubik-medium mt-4">
                    {{ $t('doctor.title') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-1/4 lg:mb-0 mb-4">
              <div
                id="register-psychologist"
                class="card flex items-center justify-center border-2 border-blue2 cursor-pointer hover:bg-light-blue"
                style="min-height: 180px"
                :class="{'bg-light-blue': registerType === 'PSYCHOLOGIST'}"
                @click="registerType = 'PSYCHOLOGIST'"
              >
                <div>
                  <img v-lazy-load data-src="@/assets/icon/icon-psychologist.svg" alt="" class="mx-auto">
                  <p class="text-primary font-rubik-medium mt-4">
                    {{ $t('psychologist.title') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <button id="btn-submit" :disabled="!registerType" class="btn btn-success rounded-full px-14 uppercase my-8" @click="handleContinue">
            {{ $t('continue') }}
          </button>
        </div>
      </yes-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data: () => ({
    registerModal: false
  }),
  computed: {
    registerType: {
      get () {
        return this.$store.state.registerType
      },
      set (val) {
        if (val === this.registerType) { return }
        return this.$store.commit('SET_REGISTER_TYPE', val)
      }
    },
    availableLocales () {
      return this.$i18n.locales
    }
  },
  methods: {
    closeModal () {
      this.registerModal = false
      this.registerType = null
    },
    handleContinue () {
      this.$store.commit('SET_REGISTER_TYPE', this.registerType)
      this.registerModal = false
      // if (this.registerType !== 'DOCTOR') {
      if (this.registerType === 'HOSPITAL' || this.registerType === 'CLINIC') {
        this.$store.commit('SET_MODAL_REGISTER', true)
      } else if (this.registerType === 'PSYCHOLOGIST') {
        this.$router.push(this.localeLocation({ path: '/register/psycholog' }))
      } else {
        this.$router.push(this.localeLocation({ path: '/register/dokter' }))
      }
    },
    handleScrollTo (to) {
      const offsetTop = document.getElementById(to).offsetTop
      scroll({
        top: offsetTop - 50,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped lang="scss">
 .img-flag {
   width: 15px;
   height: 20px;
 }
</style>
